import { useTranslation } from "react-i18next";
import { React, useEffect, useState } from "react";
import FormInput from "../../../components/FormGroup/FormInput";
import FormSelect from "../../../components/FormGroup/FormSelect";
import { usePrecandidateContext } from "../../precandidate/context/Context";
import "./stylesEdit.scss";
import { useGeneralContext } from "../../General/Context";
import Datetime from "react-datetime";
import { Files } from "../Files/Files";
import moment from "moment";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import pt from "react-phone-number-input/locale/pt";
import es from "react-phone-number-input/locale/es";
import fr from "react-phone-number-input/locale/fr";
import en from "react-phone-number-input/locale/en";
import { JobRoleDetailService } from "../../../services/JobRoleDetailService";
import { DropDownMultiCheck } from "../../Interview/AdvanceSearch/DropDownMultiCheck";

const EditPrecandidate = () => {
  const { t, i18n } = useTranslation();
  const {
    precandidate,
    setPrecandidate,
    onChange,
    managers,
    candidateSources,
    candidateSourceRCIds,
    candidateSourceDFIds,
    jobRoles,
    errors
  } = usePrecandidateContext();
  const { userInformation } = useGeneralContext();

  const [businessAreas, setBusinessAreas] = useState([]);
  const [techAreas, setTechAreas] = useState([]);
  const [techRoles, setTechRoles] = useState([]);

  function getBusinessAreas() {
    JobRoleDetailService.getAllBusinessAreas().then((data) => {
      setBusinessAreas(data);
    });
  }
  function getTechAreas() {
    JobRoleDetailService.getAllTechAreas().then((data) => {
      setTechAreas(data);
    });
  }
  function getTechRoles(techAreaId) {
    JobRoleDetailService.getAllTechRoles(techAreaId).then((data) => {
      setTechRoles(data);
    });
  }
  useEffect(() => {
    getBusinessAreas();
    getTechAreas();
  }, []);

  useEffect(() => {
    if (precandidate?.techAreaId) getTechRoles(precandidate.techAreaId);
  }, [precandidate?.techAreaId]);

  function onApplicationDaetChange(date) {
    if (moment(date).isValid())
      setPrecandidate({ ...precandidate, applicationDate: date });
  }

  function oncandidateSourceIdChange({ target }) {
    let _precandidate = { ...precandidate };
    if (!candidateSourceRCIds[target.value]) {
      _precandidate.recommendedByEmail = undefined;
      _precandidate.recommendedByName = undefined;
      _precandidate.isCapturedByMe = false;
    }
    _precandidate.candidateSourceId = target.value;
    setPrecandidate(_precandidate);
  }

  const onChangeWasCreatedByMe = () => {
    setPrecandidate({
      ...precandidate,
      isCapturedByMe:
        precandidate.isCapturedByMe === undefined
          ? true
          : !precandidate.isCapturedByMe
    });
  };

  function onChangePhoneNumber(values) {
    onChange({
      target: {
        name: "phoneNumber",
        value: values
      }
    });
  }
  const onchangeBusinessAreas = (businessAreas) => {
    setPrecandidate({ ...precandidate, businessAreas: businessAreas });
  };

  return (
    <form controlId="formPrincipal">
      <small>{precandidate.formerCompany}</small>
      <Files precandidate={precandidate} setPrecandidate={setPrecandidate} />

      <div className="row">
        <div className="col-md-4" style={{ width: "33%" }}>
          <FormInput
            controlId="formGridName"
            errorMessage={errors.fullName}
            labelText={t("Full Name")}
            type="text"
            placeholder={t("Name")}
            value={precandidate.fullName}
            onChange={onChange}
            id="fullName"
            name="fullName"
            isFieldRequired={true}
          />
        </div>
        <div className="col-md-3" style={{ width: "33%" }}>
          <FormInput
            controlId="formGridEmail"
            errorMessage={errors.emailAddress}
            labelText={t("Email Address")}
            type="email"
            placeholder={t("name@example.com")}
            value={precandidate.emailAddress}
            onChange={onChange}
            id="emailAddress"
            name="emailAddress"
            isFieldRequired={true}
            maxLength={100}
          />
        </div>
        <div className="col-md-2" style={{ width: "33%" }}>
          <div className="label-wrapper">
            <label htmlFor="personalDetailLabelPhoneNumber">
              {t("Mobile number")}
            </label>
            {errors.phoneNumber && (
              <div className="error-msg">{errors.phoneNumber}</div>
            )}
          </div>
          <PhoneInput
            className="input-field"
            errorMessage={errors.phoneNumber}
            labelText={t("Mobile number")}
            id="phoneNumber"
            name="phoneNumber"
            type="tel"
            international
            defaultCountry={
              userInformation.langCode === "ES"
                ? "ES"
                : userInformation.langCode === "EN" &&
                  userInformation.companyAbbreviation === "AGAP2NL"
                ? "NL"
                : userInformation.langCode === "EN" &&
                  userInformation.companyAbbreviation === "GMS"
                ? "DE"
                : "PT"
            }
            labels={
              i18n.language === "PT"
                ? pt
                : i18n.language === "FR"
                ? fr
                : i18n.language === "EN"
                ? en
                : es
            }
            countryCallingCodeEditable={false}
            value={precandidate?.phoneNumber}
            onChange={onChangePhoneNumber}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-3" style={{ width: "33%" }}>
          <div className="form-group">
            <div className="label-wrapper">
              <label className="label">{t("Business Area")}</label>
            </div>
            {/* <select
              onChange={onChange}
              value={precandidate.businessAreaId || ""}
              name="businessAreaId"
              title={t("Select a Business Area from the list")}
            >
              <option key={0} value="" selected>
                {t("Business Area...")}
              </option>
              {businessAreas.map((item) => (
                <option key={item.id} value={item.id}>
                  {t(item.description)}
                </option>
              ))}
            </select> */}
            <DropDownMultiCheck
              dataList={businessAreas}
              selecteds={precandidate.businessAreas || []}
              setSelecteds={onchangeBusinessAreas}
              label={t("Business Area...")}
              hideSelected={true}
            />
          </div>
        </div>
        <div className="col-md-3" style={{ width: "33%" }}>
          <div className="form-group">
            <div className="label-wrapper">
              <label className="label">{t("Technical Area")}</label>
            </div>
            <select
              onChange={onChange}
              value={precandidate.techAreaId || ""}
              name="techAreaId"
              title={t("Select a Technical Area from the list")}
            >
              <option key={0} value="" selected>
                {t("Technical Area...")}
              </option>
              {techAreas.map((item) => (
                <option key={item.id} value={item.id}>
                  {t(item.description)}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-md-3" style={{ width: "33%" }}>
          <div className="form-group">
            <div className="label-wrapper">
              <label className="label">{t("Technical Role")}</label>
            </div>
            <select
              onChange={onChange}
              value={precandidate.techRoleId || ""}
              name="techRoleId"
              title={t("Select a Technical Role from the list")}
            >
              <option key={0} value="" selected>
                {t("Technical Role...")}
              </option>
              {techRoles.map((item) => (
                <option key={item.id} value={item.id}>
                  {t(item.description)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <hr></hr>
      <div className="row">
        <div className="col-md-4">
          <FormSelect labelText={t("Assign to")} isFieldRequired={false}>
            <select
              value={precandidate.managerId || userInformation.id}
              onChange={onChange}
              id="managerId"
              name="managerId"
              required
              title={t("Selecione um item da lista.")}
            >
              {managers.map((option) => (
                <option key={option.id} value={option.id}>
                  {t(option.nickname)}
                </option>
              ))}
            </select>
          </FormSelect>
        </div>{" "}
        <div className="col-md-3">
          <div className="label-wrapper">
            {" "}
            <label className="label">{t("Apllication Date")}</label>
          </div>

          <Datetime
            value={
              precandidate.applicationDate &&
              moment(precandidate.applicationDate).format("DD-MM-YYYY")
            }
            dateFormat="DD-MM-YYYY"
            onChange={onApplicationDaetChange}
            utc={true}
            timeFormat={false}
            closeOnSelect={true}
            locale={
              i18n.language === "PT"
                ? "PT"
                : i18n.language === "FR"
                ? "FR"
                : "EN"
            }
            inputProps={{
              placeholder: t("dd-mm-yyyy")
            }}
          />
        </div>
        <div className="col-md-3">
          <FormSelect
            labelText={t("Source")}
            isFieldRequired={true}
            errorMessage={errors.candidateSourceId}
          >
            <select
              value={precandidate.candidateSourceId || ""}
              onChange={oncandidateSourceIdChange}
              id="candidateSourceId"
              required
              name="candidateSourceId"
              title={t("Selecione um item da lista.")}
            >
              <option key={0} value="" selected disabled>
                {t("Select Source...")}
              </option>
              {candidateSources.map((option) => (
                <option key={option.id} value={option.id}>
                  {t(option.description)}
                </option>
              ))}
            </select>{" "}
          </FormSelect>
        </div>
        <div className="col-md-2">
          <div className="label-wrapper">
            <label className="label">{t("Captured by me ?")}</label>
          </div>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id="isCapturedByMe"
              name="isCapturedByMe"
              onChange={onChangeWasCreatedByMe}
              value={precandidate.isCapturedByMe}
              checked={
                precandidate.createdBy === userInformation.id.toString() &&
                candidateSourceDFIds[precandidate?.candidateSourceId]
                  ? precandidate.isCapturedByMe
                  : false
              }
              disabled={
                precandidate.createdBy === userInformation.id.toString() &&
                candidateSourceDFIds[precandidate?.candidateSourceId]
                  ? false
                  : true
              }
            />
          </div>
        </div>
      </div>
      {candidateSourceRCIds[precandidate.candidateSourceId] ? (
        <div className="row">
          <div className="col">
            <FormInput
              controlId="formGridRecommendedName"
              errorMessage={errors.recommendedByName}
              labelText={t("Recommended by name")}
              type="email"
              placeholder={t("name")}
              value={precandidate.recommendedByName}
              onChange={onChange}
              id="recommendedByName"
              name="recommendedByName"
              isFieldRequired={true}
            />
          </div>
          <div className="col">
            <FormInput
              controlId="formGridRecommendedEmail"
              errorMessage={errors.recommendedByEmail}
              labelText={t("Recommended by  Email")}
              type="email"
              placeholder={t("name@example.com")}
              value={precandidate.recommendedByEmail}
              onChange={onChange}
              id="recommendedByEmail"
              name="recommendedByEmail"
              isFieldRequired={true}
            />
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="col">
            <FormInput
              controlId="formGridRecommendedName"
              errorMessage={errors.recommendedName}
              labelText={t("Recommended by name")}
              type="email"
              placeholder={t("name")}
              value={precandidate.recommendedByName}
              onChange={onChange}
              id="recommendedByName"
              name="recommendedByName"
              isFieldRequired={true}
              disabled={true}
            />
          </div>
          <div className="col">
            <FormInput
              controlId="formGridRecommendedEmail"
              errorMessage={errors.recommendedByEmail}
              labelText={t("Recommended by  Email")}
              type="email"
              placeholder={t("name@example.com")}
              value={precandidate.recommendedByEmail}
              onChange={onChange}
              id="recommendedByEmail"
              name="recommendedByEmail"
              isFieldRequired={true}
              disabled={true}
            />
          </div>
        </div>
      )}
      <div className="col-md">
        <div className="label-wrapper">
          <label>{t("Notes")}</label>
        </div>
        <textarea
          id="comment"
          name="comment"
          className="form-control"
          rows="3"
          value={precandidate.comment || ""}
          onChange={onChange}
          maxLength={500}
          placeholder={t("Your notes here...")}
        />
      </div>
    </form>
  );
};

export default EditPrecandidate;
